import React from 'react'
import ReactDOM from 'react-dom/client';

import Index from '../../components/savings-summaries/list'

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('savings-summary-index')
  if(node) {
    const root = ReactDOM.createRoot(node);
    root.render(
      <div>
        <Index/>
      </div>
    );
  }
});
